import { ReactNode } from 'react';

import Row from '../../../../../components/Row/Row';
import SVG from '../../../../../components/SVG/SVG';
import Text from '../../../../../components/Text/Text';

import infoIcon from './graphics/info.svg?raw';

import styles from './CannotContinueNote.module.css';

type CannotContinueNoteProps = { children: ReactNode };

const CannotContinueNote = ({ children }: CannotContinueNoteProps) => {
    return (
        <div className={styles.Root}>
            <div className={styles.Note}>
                <Row vertical="top">
                    <SVG src={infoIcon} className={styles.Icon} />
                    <Text>{children}</Text>
                </Row>
            </div>
        </div>
    );
};

export default CannotContinueNote;
